import { render, staticRenderFns } from "./appeals.vue?vue&type=template&id=41f5d626&scoped=true&"
import script from "./appeals.vue?vue&type=script&lang=js&"
export * from "./appeals.vue?vue&type=script&lang=js&"
import style0 from "./appeals.vue?vue&type=style&index=0&id=41f5d626&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f5d626",
  null
  
)

export default component.exports